import { Injectable } from '@angular/core';
import { RequestService } from '../requestService/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  constructor(private requestService: RequestService) { }

  /** Return data for home page */
  getHome() {
    let req = {
      url: "/api/pages/home"
    };

    return this.requestService.mainGetRequest(req);
  }

  /** Return details for an asset
   * @param assetId ID of the asset
   */
  getAssetDetails(params) {
    let req = {
      url: "/api/content/getDetails",
      req: {
        assetId: params.assetId
      }
    };
    return this.requestService.mainPostRequest(req)
  }

  /** Return similar assets.
   * @param categoryId ID of a category in which the asset exist
   * @param assetId ID of the asset
   */
  getSimilarAssets(params) {
    let req = {
      url: "/api/content/getRandomRibbons?" +
        "categoryId=" + params.categoryId +
        "&assetId=" + params.assetId +
        "&count=" + environment.features.similarCount +
        "&orderByTitle=" + environment.features.orderByTitle
    };
    return this.requestService.mainGetRequest(req)
  }

  /** Return similar assets from recommendation platform
   * @param categoryId ID of a category in which the asset exist
   * @param assetId ID of the asset
   */
  getRecoSimilarAssets(params) {
    let req = {
      url: "/api/reco/consume/18/26?" +
        "&count=" + environment.features.similarCount +
        "&assetId=" + params.assetId
    };
    return this.requestService.mainGetRequest(req)
  }


  /** Return assets for a category.
   * @param categoryId ID of a category 
   * @param offset Offset
   * @param count Count
   */
  getAssets(params) {
    let req = {
      url: "/api/content/getAssets",
      req: {
        categoryId: params.categoryId,
        offset: params.offset,
        count: params.count,
        orderByTitle: environment.features.orderByTitle
      }
    };

    return new Promise(resolve => {
      this.requestService.mainPostRequest(req).then((resp: any) => {
        resolve({
          assets: resp.data.assets,
          nextPage: resp.data.nextPage
        })
      });
    });
  }

  /** Return assets for a category (HTTP Cahced).
   * @param categoryId ID of a category 
   * @param offset Offset
   * @param count Count
   */
  getCatalogAssets(params) {
    let req = {
      url: "/api/content/getCatalogAssets?categoryId=" + params.categoryId +
        "&offset=" + params.offset +
        "&count=" + params.count +
        "&orderByTitle=" + environment.features.orderByTitle
    };

    return new Promise(resolve => {
      this.requestService.mainGetRequest(req).then((resp: any) => {
        resolve({
          assets: resp.data.assets,
          nextPage: resp.data.nextPage
        })
      });
    });
  }

  /** Return subcategories of a category and ribbon assets for each sub category (HTTP Cahced).
   * @param categoryId ID of a category 
   */
  getCatalogRibbons(params) {
    let req = {
      url: "/api/content/getCatalogRibbons?categoryId=" +
        params.categoryId +
        "&orderByTitle=" + environment.features.orderByTitle
    };

    return new Promise(resolve => {
      this.requestService.mainGetRequest(req).then((resp: any) => {
        resolve({
          ribbons: resp.data.ribbons
        })
      });
    });
  }
}